import React from 'react';
import OperationsDashboard from '../../features/dashboard/OperationsDashboard';

// Home landing. Every industry gets the Operations Dashboard here — the same
// Overview / My Tasks / Alerts home it has always rendered, with the
// null-preserving KPI fix intact. The single pest operator analytics page
// lives at /analytics (AnalyticsRouter index), NOT on the home dashboard.
export default function DashboardHome() {
  return <OperationsDashboard />;
}
